import { Button, Collapse, Row, Col, Input, Select, DatePicker, Typography } from "antd";
import dayjs from "dayjs";
const { Text } = Typography;
const CampaignsPanelInput = ({
  onChange,
  campaign,
  brandOptions,
  idx,
  handleProductChange,
  statusOptions,
  strategyOptions,
  handleBrandChange,
  mode,
}) => {
  return (
    <div>
      <Row gutter={8} style={{ marginBottom: 4 }}>
        <Col span={4}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Brand
          </Text>
        </Col>
        <Col span={5}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Product
          </Text>
        </Col>
        <Col span={5}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Variation
          </Text>
        </Col>
        <Col span={4}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Code
          </Text>
        </Col>
        <Col span={3}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Target Mail Qty
          </Text>
        </Col>
        <Col span={3}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Actual Mail Qty
          </Text>
        </Col>
      </Row>
      <Row gutter={8} style={{ marginBottom: 8 }}>
        <Col span={4}>
          <Select
            showSearch
            style={{ width: "100%" }}
            placeholder="Brand"
            optionFilterProp="children"
            value={campaign.brand}
            onChange={(val) => handleBrandChange(val, idx)}
            options={brandOptions}
            disabled={mode === "view" || mode === "edit"}
          />
        </Col>
        <Col span={5}>
          <Select
          showSearch
            style={{ width: "100%" }}
            placeholder="Product"
            value={campaign.product}
            onChange={(val) => handleProductChange(val, idx)}
            options={campaign.productOptions}
            disabled={mode === "view" || mode === "edit"}
          />
        </Col>
        <Col span={5}>
          <Select
          showSearch
            style={{ width: "100%" }}
            placeholder="Variation"
            value={campaign.variation}
            onChange={(val) => onChange(idx, "variation", val)}
            options={campaign.variationOptions}
            disabled={mode === "view" || mode === "edit"}
          />
        </Col>
        <Col span={4}>
          <Input
            placeholder="Code"
            value={campaign.code}
            onChange={(e) => onChange(idx, "code", e.target.value)}
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={3}>
          <Input
            placeholder="Target Mail Qty"
            type="number"
            min={0}
            value={campaign.mailQty}
            onChange={(e) => onChange(idx, "mailQty", e.target.value)}
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={3}>
          <Input
            placeholder="Actual Mail Qty"
            type="number"
            min={0}
            value={campaign.actualMailQty}
            onChange={(e) =>
              onChange(idx, "actualMailQty", e.target.value === null ? "" : e.target.value)
            }
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
      </Row>
      <Row gutter={8} style={{ marginBottom: 4 }}>
        <Col span={4}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Mail Date
          </Text>
        </Col>
        <Col span={3}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Rate %
          </Text>
        </Col>
        <Col span={3}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Strategy
          </Text>
        </Col>
        <Col span={6}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Strategy Desc
          </Text>
        </Col>
        <Col span={3}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Status
          </Text>
        </Col>
        <Col span={5}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Status Desc
          </Text>
        </Col>
      </Row>
      <Row gutter={8} style={{ marginBottom: 8 }}>
        <Col span={4}>
          <DatePicker
            style={{ width: "100%", height: "32px" }}
            value={campaign.mailDate}
            onChange={(date) => onChange(idx, "mailDate", date)}
            disabledDate={(current) => current && current < dayjs().startOf("day")}
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={3}>
          <Input
            placeholder="Rate %"
            type="number"
            value={campaign.rateOfResponse}
            min={0}
            onChange={(e) => onChange(idx, "rateOfResponse", e.target.value)}
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={3}>
          <Select
          showSearch
            style={{ width: "100%" }}
            placeholder="Strategy"
            value={campaign.strategy}
            onChange={(val) => onChange(idx, "strategy", val)}
            options={strategyOptions}
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={6}>
          <Input
            placeholder="Strategy Desc"
            value={campaign.strategyDesc}
            onChange={(e) => onChange(idx, "strategyDesc", e.target.value)}
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={3}>
          <Select
          showSearch
            style={{ width: "100%" }}
            placeholder="Status"
            value={campaign.status}
            onChange={(val) => onChange(idx, "status", val)}
            options={statusOptions}
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={5}>
          <Input
            placeholder="Status Desc"
            value={campaign.statusDesc}
            onChange={(e) => onChange(idx, "statusDesc", e.target.value)}
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
      </Row>
      <Row gutter={8} style={{ marginBottom: 4 }}>
        <Col span={4}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Printer
          </Text>
        </Col>
        <Col span={4}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Lettershop
          </Text>
        </Col>
        <Col span={4}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Postage
          </Text>
        </Col>
        <Col span={4}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Data Processing
          </Text>
        </Col>
        <Col span={4}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Misc Fee
          </Text>
        </Col>
      </Row>
      <Row gutter={8} style={{ marginBottom: 8 }}>
        <Col span={4}>
          <Select
          showSearch
            style={{ width: "100%" }}
            placeholder="Printer"
            value={campaign.printer}
            onChange={(val) => onChange(idx, "printer", val)}
            options={campaign.printerOptions}
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={4}>
          <Select
          showSearch
            style={{ width: "100%" }}
            placeholder="Lettershop"
            value={campaign.lettershop}
            onChange={(val) => onChange(idx, "lettershop", val)}
            options={campaign.lettershopOptions}
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={4}>
          <Select
          showSearch
            style={{ width: "100%" }}
            placeholder="Postage"
            value={campaign.postage}
            onChange={(val) => onChange(idx, "postage", val)}
            options={campaign.postageOptions}
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={4}>
          <Select
          showSearch
            style={{ width: "100%" }}
            placeholder="Data Processing"
            value={campaign.dataProcessing}
           
            onChange={(val) => onChange(idx, "dataProcessing", val)}
            options={campaign.dataProcessingOptions}
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={4}>
          <Input
            placeholder="Misc Fee"
            type="number"
            min={0}
            step="0.01"
            value={campaign.costs.miscFee}
            onChange={(e) =>
              onChange(idx, "costs", {
                ...campaign.costs,
                miscFee: e.target.value,
              })
            }
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
      </Row>
      <Row gutter={8} style={{ marginBottom: 4 }}>
        <Col span={4}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Printer Cost
          </Text>
        </Col>
        <Col span={4}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Lettershop Cost
          </Text>
        </Col>
        <Col span={4}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            Postage Cost
          </Text>
        </Col>
        <Col span={4}>
          <Text className="d-block" style={{ fontSize: "12px" }}>
            DP Cost
          </Text>
        </Col>
        <Col span={4}></Col>
      </Row>
      <Row gutter={8} style={{ marginBottom: 8 }}>
        <Col span={4}>
          <Input
            placeholder="Printer Cost"
            type="number"
            min={0}
            step="0.01"
            value={campaign.costs.printerCost}
            onChange={(e) =>
              onChange(idx, "costs", {
                ...campaign.costs,
                printerCost: e.target.value,
              })
            }
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={4}>
          <Input
            placeholder="Lettershop Cost"
            type="number"
            min={0}
            step="0.01"
            value={campaign.costs.lettershopCost}
            onChange={(e) =>
              onChange(idx, "costs", {
                ...campaign.costs,
                lettershopCost: e.target.value,
              })
            }
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={4}>
          <Input
            placeholder="Postage Cost"
            type="number"
            min={0}
            step="0.01"
            value={campaign.costs.postageCost}
            onChange={(e) =>
              onChange(idx, "costs", {
                ...campaign.costs,
                postageCost: e.target.value,
              })
            }
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={4}>
          <Input
            placeholder="Data Processing Cost"
            type="number"
            min={0}
            step="0.01"
            value={campaign.costs.dataProcessingCost}
            onChange={(e) =>
              onChange(idx, "costs", {
                ...campaign.costs,
                dataProcessingCost: e.target.value,
              })
            }
            disabled={mode === "view" || campaign.isGeneratingActions}
          />
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  );
};

export default CampaignsPanelInput;
